type GlobalDataType = any // Replace `any` with a more specific type if you have one

export const useGlobalData = (): Ref<GlobalDataType | null> => {
    return useState<GlobalDataType | null>('global-data', () => null)
}

export default () => {
    const globalData = useGlobalData()

    function setGlobalData(data: GlobalDataType | null): void {
        if (data !== null) {
            globalData.value = data
        }
    }

    return {
        globalData,
        setGlobalData,
    }
}
